import React from "react";
import { Grid } from "@mui/material";

const Modal = ({
  isOpen,
  onClose,
  data,
  onApprove,
  onClientApprove,
  onReject,
}) => {
  if (!isOpen) return null;


  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-3/4 max-w-xl p-6">
        <h2 className="text-lg font-semibold mb-4">Recce Details</h2>
        <Grid container spacing={2} className="mb-4">
        <Grid item xs={12} md={4}>
        <p><strong>Signage Id:</strong> {data.signageID || "Na"}</p>
  </Grid>
  <Grid item xs={12} md={4} >
  <p><strong>Signage Type:</strong> {data.signageType || "Na"}</p>
  </Grid>
  <Grid item xs={12} md={4}>          
    <p><strong>Height:</strong> {data.height || "Na"}</p>
  </Grid>
  <Grid item xs={12} md={4}>          
  <p><strong>Width:</strong> {data.width || "Na"}</p>
  </Grid>
  <Grid item xs={12} md={4}>          
  <p><strong>Recce Pdf:</strong> {data.reccepdf || "Na"}</p>
  </Grid>
  <Grid item xs={12} md={4}>          
  <p><strong>Admin Status:</strong> {data.adminStatus || "Na"}</p>
  </Grid>
  <Grid item xs={12} md={4}>          
  <p><strong>Client Status:</strong> {data.clientStatus || "Na"}</p>
  </Grid>
  <Grid item xs={12} md={4}>          
  <p><strong>Ip Name:</strong> {data.ipName || "Na"}</p>
  </Grid>
  <Grid item xs={12} md={4}>          
  <p><strong>Creation Date:</strong> {data.creationDate || "Na"}</p>
  </Grid>
  <Grid item xs={12} md={4}>          
  <p><strong>Approver:</strong> {data.approver || "Na"}</p>
  </Grid>
  <Grid item xs={12} md={4}>          
  <p><strong>Approval Date:</strong> {data.approvalDate || "Na"}</p>
  </Grid>
        </Grid>

        <div className="flex justify-end space-x-2">
        {(() => {
    if (data?.adminStatus === "REJECTED") {
      // When admin status is REJECTED, show no action buttons
      return null;
    } else if (data?.adminStatus === "APPROVED" && data?.clientStatus !== "SENT") {
      // When admin status is APPROVED but client status is not SENT
      return (
        <button
          onClick={() => onClientApprove(data)}
          className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
        >
          Client Sent
        </button>
      );
    } else if (data?.adminStatus !== "APPROVED" && data?.adminStatus !== "REJECTED") {
      // When admin status is neither APPROVED nor REJECTED
      return (
        <>
          <button
            onClick={() => onApprove(data)}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Approve
          </button>
          <button
            onClick={() => onReject(data)}
            className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
          >
            Reject
          </button>
          <button
          onClick={() => onClientApprove(data)}
          className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
        >
          Client Sent
        </button>
        </>
      );
    }
  })()}
 

  {/* Cancel Button */}
  <button
    onClick={onClose}
    className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
  >
    Cancel
  </button>
</div>
      </div>
    </div>
  );
};

export default Modal;
